import React from 'react'
import { withRouter } from 'react-router'
import { view } from 'react-easy-state'
import { Button, Icon } from 'antd'
import globalStore from 'store'

class PaperListSider extends React.Component {

  showPaper = (paperId) => {
    this.props.history.push(`/papers/${paperId}`)
  }

  goBack = () => {
    const pageState = globalStore.ui.students.papers.show
    const { backUrl } = pageState
    this.props.history.push(backUrl)
  }

  render() {

    const pageState = globalStore.ui.students.papers.show

    const { subject, course } = pageState

    return (<div className="lecture-list-sider" id="paperListSider">
      <div className="header">
        <Button shape="circle" onClick={this.goBack}><Icon type="left" /></Button>
        {/* <Button shape="circle"><Icon type="setting" /></Button> */}
      </div>
      <div className="course-detail-sider">
        <div className="course-image">
          <img src={subject.image_url} alt={subject.name} />
        </div>
        <div className="course-name"><h3>{subject.name}</h3></div>
      </div>
      <div className="menu-list">
        <Button type="link" onClick={() => this.props.history.push(`/courses/${course.id}/subjects`)}>
          <Icon type="video-camera" /> <span>Course Content</span>
        </Button>
        <Button type="link" className="active" onClick={() => false}>
          <Icon type="copy" /> <span>Test Content</span>
        </Button>
      </div>
    </div>)
  }
}

export default withRouter(view(PaperListSider))
